(() => {
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!ios || window.ncGlproMessengerRoutingReady) return;
  window.ncGlproMessengerRoutingReady = true;
  const webUrl = 'https://m.me/glprocorehk';
  const nativeUrl = 'fb-messenger-public://user-thread/855922487598801?intent_trigger=mme&source_id=1441792&nav=discover';
  const enhance = scope => {
    scope.querySelectorAll('a[href="' + webUrl + '"]').forEach(link => {
      if (!link.closest('[data-glhk], [data-glc]')) return;
      link.href = nativeUrl;
      link.target = '_self';
    });
    scope.querySelectorAll('[data-glhk-messenger-fallback]').forEach(element => {element.hidden = false;});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once:true});
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (link && link.getAttribute('href') === webUrl && link.closest('[data-glhk], [data-glc]')) enhance(document);
  }, true);
})();
